export default {"src":"/_next/static/media/scarlett_black.b7c9b61d.svg","height":38,"width":257,"blurWidth":0,"blurHeight":0};